import {ToServerId} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {
  BioentityNote,
  BioentityServerNote,
  BioentityServerNoteVersion,
  ServerNote,
} from 'notebook/util/NoteUtilConstants';
import * as net from 'util/Net';

const NoteDAO = {
  get(fileId: string): JQueryPromise<BioentityServerNote> {
    return net.getJSON(`/1/api/files/${fileId}/note-versions/latest`);
  },

  update(fileId: string, note: BioentityNote | ServerNote<ToServerId>): JQueryPromise<{cidIdMap: CidIdMap}> {
    return net.postJSON({
      url: '/1/api/note-parts/action/sync',
      data: {
        id: fileId,
        note,
      },
    });
  },

  getVersions(fileId: string): JQueryPromise<Array<BioentityServerNoteVersion>> {
    return net.getJSON(`/1/api/files/${fileId}/note-versions/`);
  },

  getVersion(fileId: string, noteVersionId?: string): JQueryPromise<BioentityServerNoteVersion> {
    return net.getJSON(`/1/api/files/${fileId}/note-versions/${noteVersionId}`);
  },
};

export default NoteDAO;
